import { ModalSelectDate } from "./modalSelectDate.js";
import { ModalTiteledWindow } from "./modalWindow.js";
import { RadioButtons } from "../radiobuttons.js";
import { sortObjectArray } from "../util.js";
import { groupData } from "../util.js";

export class ModalShowPupilNotes extends ModalTiteledWindow {

   constructor(app, selector) {
      super();
      this.app = app;
      this.user = this.app.dm.getUserSelf();
      this.selector = selector;
      this.addClass('modal-show-absences');
      if (this.selector.class) {
         this.setTitle(`${this.selector.class.name}: Schüler-Anmerkungen`);
      }
      else {
         this.setTitle(`${this.selector.pupil.lastName}, ${this.selector.pupil.firstName}: Schüler-Anmerkungen`);
      }

      this.setBody(`
         <div class="select"><span class="help icon-info" selector=".modal-pupil-notes" style="position: absolute; right: 0.5rem;"></span>
            <div class="date-range">
               <div class="range">
                  von 
                  <div class="date date-from" date="from"></div>
                  bis
                  <div class="date date-to" date="to"></div>
               </div>
            </div>
         </div>
         <div class="absences"></div>
      `);

      this.dateRange = new RadioButtons('date-range', {
            onSelect: (value) => this.setRangeType(value)
         },
         [
            { label: "Schuljahr", value: "full-year" },
            { label: "Zeitraum",  value: "date-range" },
         ]
      );
      this.panel.querySelector('.select .date-range').prepend(this.dateRange.getElement());

      this.elDateFrom = this.panel.querySelector('.date-range .date-from');
      this.elDateTo = this.panel.querySelector('.date-range .date-to');

      [this.elDateFrom, this.elDateTo].forEach(el => el.onclick = (event) => {
         const elDate = event.currentTarget;
         new ModalSelectDate({ onSelect: (value) => {
            elDate.dataset.date = value.isoDate();
            elDate.innerText = value.toGermanDate();
            localStorage.setItem('pupilNotesDatesRange', JSON.stringify({ from: this.elDateFrom.dataset.date, to: this.elDateTo.dataset.date }));
            this.loadData();
         }});
      });

      this.dateRange.setValue('full-year', true);
      
      this.setupHelp(this.app);

      setTimeout(() => this.show(), 1);

   }

   setRangeType(type) {

      this.sortKeys = [];

      if (type === 'full-year') {
         this.panel.querySelector('.date-range .range').style.display = 'none';
      }
      else {

         let range;
         try {
            range = JSON.parse(localStorage.getItem('pupilNotesDatesRange'));
            if (!range) throw new Error();
         }
         catch(e)  { range = { from: (new Date()).isoDate(), to: (new Date()).isoDate() }; }

         this.panel.querySelector('.date-range .range').style.display = 'flex';

         this.elDateFrom.dataset.date = range.from;
         this.elDateFrom.innerText = Date.fromString(range.from).toGermanDate();
         this.elDateTo.dataset.date = range.to;
         this.elDateTo.innerText = Date.fromString(range.to).toGermanDate();
      }

      this.loadData();

   }

   async loadData() {

      let params = {
         action: 'classnote-get-items',
         type: ['pupilNote', 'smartphoneViolation'],
      };

      if (this.selector.class) params.classId = this.selector.class.id;
      else params.pupilId = this.selector.pupil.id;

      let data = (await this.app.dm.sinRequest(params)).data;

      if (this.dateRange.getValue() !== 'full-year') {
         const dateFrom = this.elDateFrom.dataset.date;
         const dateTo = this.elDateTo.dataset.date;
         data = data.filter(note => {
            return note.dateFrom.isBetween(dateFrom, dateTo) ||  note.dateTo.isBetween(dateFrom, dateTo) || (note.dateFrom < dateFrom && note.dateTo > dateTo);
         });
      }

      this.data = data;

      this.updateNotes();

   }

   updateNotes() {

      if (!this.sortKeys.includes('<.pupil.normedLastName')) this.sortKeys.push('<.pupil.normedLastName');

      this.data = this.data.map(item => {
         item.pupil = this.user.type === 'pupil' ? this.user : this.app.dm.getUser(item.pupilId);
         item.creator = this.app.dm.getUser(item.creatorId);
         return item;
      });

      sortObjectArray(this.data, this.sortKeys);

      let html = `<table class="bl-2 br-2 bt-2 bb-2">
      <thead>
         <tr>
            ${this.user.type === 'teacher' ? 
               `<th class="ta-left" data-sort-key="<.pupil.normedLastName">Nachname</th>
               <th class="ta-left" data-sort-key="<.pupil.normedFirstName">Vorname</th>`
               : ''
            }
            <th class="" data-sort-key="<.dateFrom">Datum</th>
            <th class="" data-sort-key="<.creator.short">L</th>
            <th class="">Notiz</th>
         </tr>
      </thead><tbody>`;

      for (let note of this.data) {
         html += `<tr data-pupil-id="${note.id}">`;
         if (this.user.type === 'teacher') html += `<td>${note.pupil.lastName}</td><td>${note.pupil.firstName}</td>`;
         html += `<td>${Date.simplifyDatePeriod(note.dateFrom, note.dateTo)}</td><td class="">${note.creator.short}</td><td class="">${note.type === 'smartphoneViolation' ? '📱 Handy-Verstoß ' : ''}${note.note}</td></tr>`;
      }

      html += `</tbody></table>`;
      this.panel.querySelector('.absences').innerHTML = html;

      this.panel.querySelectorAll('th').forEach(elTh => {
         const indexColor = [ .5, .3, .2 ];
         for (let i=0; i<this.sortKeys.length; ++i) {
            if (elTh.dataset.sortKey === this.sortKeys[i]) {
               elTh.style.backgroundColor = `rgba(255,0,0,${indexColor[i]})`;
            }
         }
      });

      this.panel.querySelectorAll('.absences th').forEach(elTh => {
         let sortKey = elTh.dataset.sortKey;
         if (sortKey) {
            elTh.onclick = () => this.collectSortKey(elTh, sortKey);
         }
      });

   }

   applyAbsencesToPupils(absences) {

      let pupils = this.class.pupils.map(pupilId => {
         let pupil = this.app.dm.getUser(pupilId);
         const abs = absences.find(item => item.pupilId === pupil.id);
         if (abs) {
            pupil.absences = abs;
         }
         else pupil.absences = { hj1: 0, hj2: 0, sum: 0 };
         return pupil;
      });      

      return pupils;

   }


   showDetails(pupilId) {

      const data = this.data.filter(item => item.pupilId === pupilId);
      const pupil = this.app.dm.getUser(pupilId);
      new ModalShowAbsentItemDetails(this.app, "Versäumte Hausaufgaben", pupil, data);

   }

   collectSortKey(elTh, sortKey) {

      const indexColor = [ .5, .3, .2 ];

      if (!this.collectingSortKeys) {
         this.sortKeys = [ sortKey ];
         this.collectingSortKeys = true;
         setTimeout(() => {
            this.collectingSortKeys = false;
            this.updateNotes();
         }, 1000);
         this.panel.querySelectorAll('th').forEach(elTh => elTh.style.removeProperty('background-color'));
         elTh.style.backgroundColor = `rgba(255,0,0,${indexColor[0]})`;
      }
      else {
         if (!this.sortKeys.includes(sortKey) && this.sortKeys.length < 3) {
            this.sortKeys.push(sortKey);
            elTh.style.backgroundColor = `rgba(255,0,0,${indexColor[this.sortKeys.length-1]})`;
         }
      }

   }

}
